  (function () {
    'use strict';

    function init(root) {
      // Guard: não reinicializa o mesmo nó (snippet duplicado / re-render).
      if (!root || root.dataset.cofWaInit === '1') return;
      root.dataset.cofWaInit = '1';

      var phone = (root.getAttribute('data-wa-phone') || '').replace(/\D/g, '');
      var overlay = root.querySelector('[data-wa-overlay]');
      var modal = root.querySelector('[data-wa-modal]');
      var fab = root.querySelector('[data-wa-open]');
      if (!overlay || !modal || !fab) return;

      var nameInput = root.querySelector('[data-wa-name]');
      var phoneInput = root.querySelector('[data-wa-phone-input]');
      var phoneHint = root.querySelector('[data-wa-phone-hint]');
      var continueBtn = root.querySelector('[data-wa-continue]');
      var sendLink = root.querySelector('[data-wa-send]');
      var steps = root.querySelectorAll('[data-wa-step]');
      var dots = root.querySelectorAll('[data-wa-dot]');

      /* ANL-08 — o que faz o lead deixar de evaporar. */
      var emailInput = root.querySelector('[data-wa-email]');
      var emailHint = root.querySelector('[data-wa-email-hint]');
      var consentInput = root.querySelector('[data-wa-consent]');
      var leadForm = root.querySelector('#cof-wa-lead-form');

      /* ⚠️ O ESTADO CONTINUA SÓ NA PÁGINA — a persistência é do formulário.
         Antes da ANL-08 este comentário dizia "não persiste em banco" e era a
         descrição exata do defeito: quatro etapas de atrito terminando num
         `wa.me`, e quem não mandava a mensagem sumia sem rastro. Agora o
         registro é criado na Shopify; o objeto abaixo segue sendo só a memória
         de curto prazo da interação. */
      var state = { name: '', phone: '', email: '', consent: false, interest: '', profile: '', step: 1 };
      var lastFocused = null;

      /* ---------- Mobile viewport sync (teclado) ---------- */
      var viewportSynced = false;
      // `window.innerWidth > 767` respondia por uma media query e não é a mesma
      // coisa: inclui a barra de rolagem e não reavalia sozinho. O sheet e este
      // guard têm de concordar sobre o que é mobile, ou o JS sincroniza uma
      // altura que o CSS ignora — e vice-versa.
      var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;

      function isMobile() {
        return mqMobile ? mqMobile.matches : window.innerWidth <= 767;
      }

      function syncMobileViewport() {
        if (!isMobile() || overlay.hidden) return;
        var vv = window.visualViewport;
        var height = vv ? vv.height : window.innerHeight;
        var top = vv ? vv.offsetTop : 0;
        root.style.setProperty('--cof-wa-vvh', height + 'px');
        root.style.setProperty('--cof-wa-vv-top', top + 'px');
      }

      function keepFocusedInputVisible() {
        var active = document.activeElement;
        if (!modal || !active || !modal.contains(active)) return;
        if (!active.classList || !active.classList.contains('cof-wa-lead__input')) return;
        // Dois quadros: o primeiro ainda é o layout de antes do resize do
        // viewport, e rolar nele leva o campo para o lugar errado.
        // `block: 'nearest'` e sem `smooth` de propósito — o scroll suave corre
        // em paralelo com o que o próprio navegador faz ao focar o campo, e os
        // dois juntos param no meio do caminho.
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (document.activeElement !== active) return;
            try { active.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
            catch (e) { active.scrollIntoView(false); }
          });
        });
      }

      function onViewportChange() { syncMobileViewport(); keepFocusedInputVisible(); }

      function attachViewportListeners() {
        if (viewportSynced) return;
        viewportSynced = true;
        var vv = window.visualViewport;
        if (vv) {
          vv.addEventListener('resize', onViewportChange, { passive: true });
          vv.addEventListener('scroll', onViewportChange, { passive: true });
        }
        window.addEventListener('resize', syncMobileViewport, { passive: true });
        modal.addEventListener('focusin', onViewportChange, { passive: true });
        modal.addEventListener('focusout', syncMobileViewport, { passive: true });
        syncMobileViewport();
      }

      function detachViewportListeners() {
        if (!viewportSynced) return;
        viewportSynced = false;
        var vv = window.visualViewport;
        if (vv) {
          vv.removeEventListener('resize', onViewportChange);
          vv.removeEventListener('scroll', onViewportChange);
        }
        window.removeEventListener('resize', syncMobileViewport);
        modal.removeEventListener('focusin', onViewportChange);
        modal.removeEventListener('focusout', syncMobileViewport);
        // Restaura CSS vars para estado normal
        root.style.setProperty('--cof-wa-vvh', '100dvh');
        root.style.setProperty('--cof-wa-vv-top', '0px');
      }

      /* ---------- Scroll lock ---------- */
      // `body { overflow: hidden }` não segura o Safari no iOS: a página continua
      // rolando por baixo do sheet, e como o overlay é `position: fixed` ancorado
      // no layout viewport, esse deslocamento tira o sheet de lugar justamente
      // quando o teclado está aberto. Travar por `position: fixed` com o desvio
      // guardado é o que de fato para a página — e devolve a posição ao fechar.
      var scrollLockY = 0;
      var scrollLocked = false;

      function lockScroll() {
        if (scrollLocked) return;
        scrollLocked = true;
        scrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var body = document.body;
        body.style.position = 'fixed';
        body.style.top = (-scrollLockY) + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
      }

      function unlockScroll() {
        if (!scrollLocked) return;
        scrollLocked = false;
        var body = document.body;
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        body.style.overflow = '';
        window.scrollTo(0, scrollLockY);
      }

      function digits(value) { return (value || '').replace(/\D/g, ''); }

      function emailValido(v) {
        /* Deliberadamente frouxo: validação rígida de e-mail rejeita endereço
           legítimo e o custo disso é um lead perdido. Quem decide de verdade é
           a Shopify, no POST. */
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
      }

      function isStep1Valid() {
        return state.name.trim().length >= 2
          && digits(state.phone).length >= 10
          && emailValido(state.email)
          && state.consent === true;
      }

      function syncContinue() {
        continueBtn.disabled = !isStep1Valid();
      }

      /* ---------- ANL-08: telemetria e persistência ---------- */

      function publicar(nome, dados) {
        /* Nunca deixa a telemetria derrubar o modal. E sem PII: a camada de
           dados descarta, mas não se manda o que não se quer que vaze. */
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('cofcof:' + nome, dados || {});
          }
        } catch (e) { /* silêncio proposital */ }
      }

      function slug(v) {
        return (v || '').toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      }

      function contexto() {
        /* Reusa a MESMA lógica que decide a origem do pedido, para o lead e a
           venda nunca contarem histórias diferentes.
         *
         * ⚠️ NÃO BASTA LER `cof_ft`/`cof_lt` DO ARMAZENAMENTO, e isso foi medido:
         * a primeira versão fazia só isso e, numa visita chegando por
         * `?utm_source=instagram&utm_campaign=lote-mar`, gravou o lead como
         * `origem-direto` e `Campanha: (nenhuma)`. A causa é que aquelas chaves
         * só existem quando `atribuicao_enabled` está LIGADO — o lead passava a
         * depender, em silêncio, da chave de outra funcionalidade.
         *
         * A saída é instanciar o próprio módulo de atribuição, que fica exposto
         * mesmo com a flag desligada: mesma lógica, uma fonte só, sem herdar a
         * chave alheia. */
        var ft = null, lt = null;
        try {
          if (window.CofCofAtribuicao && window.CofCofAtribuicao.criarAtribuicao) {
            var a = window.CofCofAtribuicao.criarAtribuicao({
              agora: function () { return Date.now(); },
              local: window.localStorage,
              sessao: window.sessionStorage,
              url: window.location.href,
              referrer: document.referrer,
              enviar: function () { return Promise.resolve(); },
            });
            var e = a.registrar();
            return { ft: e.ft || {}, lt: e.lt || {} };
          }
        } catch (e) { /* cai para a leitura crua abaixo */ }
        try { ft = JSON.parse(window.localStorage.getItem('cof_ft') || 'null'); } catch (e) {}
        try { lt = JSON.parse(window.sessionStorage.getItem('cof_lt') || 'null'); } catch (e) {}
        return { ft: ft || {}, lt: lt || {} };
      }

      function montarPayload() {
        var ctx = contexto();
        var origem = ctx.lt.utm_source || ctx.lt.referrer || ctx.ft.utm_source || '(direto)';
        var tags = ['lead-site', 'interesse-' + slug(state.interest), 'perfil-' + slug(state.profile), 'origem-' + slug(origem)];
        var nota = [
          'Lead do modal de WhatsApp.',
          'WhatsApp: ' + digits(state.phone),
          'Interesse: ' + state.interest,
          'Perfil: ' + state.profile,
          'Origem: ' + origem,
          'Campanha: ' + (ctx.lt.utm_campaign || '(nenhuma)'),
          'Página: ' + (window.location && window.location.pathname ? window.location.pathname : '/'),
          'Aceite de contato: sim, em ' + new Date().toISOString(),
        ].join(' | ');
        return { tags: tags.join(', '), nota: nota };
      }

      /* Guarda o envio que falhou e tenta de novo no próximo carregamento.
         É o fallback que sobrou depois de o debate descartar `form.submit()`:
         submeter navegaria para /contact e mataria a ida ao WhatsApp. */
      function guardarPendente(corpo) {
        try { window.localStorage.setItem('cof_lead_pendente', corpo); } catch (e) {}
      }

      function enviarCorpo(corpo) {
        /* `keepalive` é o que permite o POST sobreviver à navegação que o
           próprio clique provoca. Sem ele, o navegador cancela a requisição no
           meio e o lead se perde exatamente no momento em que ele existe. */
        return fetch(leadForm.getAttribute('action') || '/contact', {
          method: 'POST',
          body: corpo,
          keepalive: true,
          headers: { Accept: 'application/json, text/html' },
        });
      }

      function enviarLead() {
        if (!leadForm) return;
        var p = montarPayload();
        var set = function (sel, valor) {
          var el = leadForm.querySelector(sel);
          if (el) el.value = valor;
        };
        set('[data-wa-f-nome]', state.name.trim());
        set('[data-wa-f-email]', state.email.trim());
        set('[data-wa-f-fone]', digits(state.phone));
        set('[data-wa-f-tags]', p.tags);
        set('[data-wa-f-nota]', p.nota);

        var corpo;
        try { corpo = new URLSearchParams(new FormData(leadForm)).toString(); } catch (e) { return; }
        var body = corpo;
        try {
          enviarCorpo(body).catch(function () { guardarPendente(body); });
        } catch (e) {
          guardarPendente(body);
        }
      }

      /* Reenvio do que ficou pendente. Roda uma vez, no boot. */
      function reenviarPendente() {
        var corpo = null;
        try { corpo = window.localStorage.getItem('cof_lead_pendente'); } catch (e) {}
        if (!corpo) return;
        try { window.localStorage.removeItem('cof_lead_pendente'); } catch (e) {}
        try {
          enviarCorpo(corpo).catch(function () { guardarPendente(corpo); });
        } catch (e) { guardarPendente(corpo); }
      }

      function showStep(n) {
        /* ⚠️ O evento dispara na ENTRADA da etapa, e é o debate que exigiu isso:
           medindo só o botão da etapa 1 não dá para separar "abandonou na 3" de
           "nunca chegou na 3" — que é a pergunta inteira desta tarefa. */
        if (n !== state.step) publicar('lead_step', { etapa: n });
        state.step = n;
        for (var i = 0; i < steps.length; i++) {
          var sn = parseInt(steps[i].getAttribute('data-wa-step'), 10);
          steps[i].hidden = sn !== n;
        }
        for (var d = 0; d < dots.length; d++) {
          var dn = parseInt(dots[d].getAttribute('data-wa-dot'), 10);
          dots[d].classList.toggle('is-active', dn <= n);
        }
        if (n === 4) buildSummary();
        // Foco no primeiro elemento útil da etapa.
        var focusTarget = steps[n - 1] && steps[n - 1].querySelector('input, .cof-wa-lead__option, .cof-wa-lead__send, .cof-wa-lead__primary:not([disabled])');
        if (focusTarget) { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }
      }

      function markSelected(group, value) {
        var opts = group.querySelectorAll('.cof-wa-lead__option');
        for (var i = 0; i < opts.length; i++) {
          opts[i].classList.toggle('is-selected', opts[i].getAttribute('data-wa-value') === value);
        }
      }

      function buildMessage() {
        var lines = [
          'Olá, meu nome é ' + state.name.trim() + '.',
          'Meu WhatsApp é ' + digits(state.phone) + '.',
          'Tenho interesse em: ' + state.interest + '.',
          'Meu perfil: ' + state.profile + '.',
          'Vim pelo site da CofCof.'
        ];
        return lines.join('\n');
      }

      function buildSummary() {
        root.querySelector('[data-wa-summary-name]').textContent = state.name.trim();
        root.querySelector('[data-wa-summary-phone]').textContent = state.phone.trim();
        root.querySelector('[data-wa-summary-interest]').textContent = state.interest;
        root.querySelector('[data-wa-summary-profile]').textContent = state.profile;
        sendLink.setAttribute('href', 'https://wa.me/' + phone + '?text=' + encodeURIComponent(buildMessage()));
      }

      // ---------- Abrir / fechar ----------
      function open() {
        lastFocused = document.activeElement;
        overlay.hidden = false;
        root.classList.add('is-open');
        lockScroll();
        // força reflow p/ transição de entrada
        void overlay.offsetWidth;
        overlay.classList.add('is-visible');
        showStep(1);
        syncContinue();
        attachViewportListeners();
      }

      function close() {
        detachViewportListeners();
        overlay.classList.remove('is-visible');
        root.classList.remove('is-open');
        unlockScroll();
        var done = function () {
          overlay.hidden = true;
          overlay.removeEventListener('transitionend', done);
        };
        // fallback caso transitionend não dispare (reduced-motion)
        overlay.addEventListener('transitionend', done);
        window.setTimeout(done, 350);
        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
        }
      }

      // ---------- Listeners ----------
      fab.addEventListener('click', open);

      root.querySelectorAll('[data-wa-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });

      // Clique fora (no overlay, não no modal) fecha.
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });

      // ESC fecha.
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && !overlay.hidden) close();
      });

      // Etapa 1: validação reativa.
      nameInput.addEventListener('input', function () { state.name = nameInput.value; syncContinue(); });
      phoneInput.addEventListener('input', function () {
        state.phone = phoneInput.value;
        phoneInput.classList.remove('is-invalid');
        if (phoneHint) phoneHint.hidden = true;
        syncContinue();
      });

      if (emailInput) {
        emailInput.addEventListener('input', function () {
          state.email = emailInput.value;
          emailInput.classList.remove('is-invalid');
          if (emailHint) emailHint.hidden = true;
          syncContinue();
        });
      }

      if (consentInput) {
        consentInput.addEventListener('change', function () {
          state.consent = !!consentInput.checked;
          syncContinue();
        });
      }

      continueBtn.addEventListener('click', function () {
        if (!isStep1Valid()) {
          if (digits(state.phone).length < 10) {
            phoneInput.classList.add('is-invalid');
            if (phoneHint) phoneHint.hidden = false;
          }
          if (!emailValido(state.email) && emailInput) {
            emailInput.classList.add('is-invalid');
            if (emailHint) emailHint.hidden = false;
          }
          return;
        }
        showStep(2);
      });

      /* ---------- ANL-08: o clique que fecha o lead ----------
         ⚠️ SEM `preventDefault`, E ISSO É DECISÃO DO DEBATE.
         A tentação é interceptar, esperar o `fetch` e só então abrir o
         WhatsApp — e aí o `window.open` cai no bloqueador de pop-up, porque
         deixou de ser resposta direta a um gesto do usuário. A promessa
         inegociável é "o WhatsApp abre de qualquer jeito": então o link
         continua sendo um link, e o envio viaja em `keepalive` ao lado. */
      if (sendLink) {
        sendLink.addEventListener('click', function () {
          publicar('generate_lead', {
            interesse: state.interest,
            perfil: state.profile,
            etapa: 4,
            pagina: window.location && window.location.pathname ? window.location.pathname : '/',
          });
          enviarLead();
        });
      }

      // Etapa 2: interesse (clique seleciona e avança).
      var interestGroup = root.querySelector('[data-wa-interest]');
      interestGroup.addEventListener('click', function (e) {
        var opt = e.target.closest('.cof-wa-lead__option');
        if (!opt) return;
        state.interest = opt.getAttribute('data-wa-value');
        markSelected(interestGroup, state.interest);
        showStep(3);
      });

      // Etapa 3: perfil (clique seleciona e avança).
      var profileGroup = root.querySelector('[data-wa-profile]');
      profileGroup.addEventListener('click', function (e) {
        var opt = e.target.closest('.cof-wa-lead__option');
        if (!opt) return;
        state.profile = opt.getAttribute('data-wa-value');
        markSelected(profileGroup, state.profile);
        showStep(4);
      });

      // Voltar.
      root.querySelectorAll('[data-wa-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (state.step > 1) showStep(state.step - 1);
        });
      });

      syncContinue();
      reenviarPendente();
    }

    function boot() {
      var roots = document.querySelectorAll('[data-cof-wa-lead]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
